import * as React from 'react';
import {
  Card,
  CardContent,
  Link as MaterialLink,
  Typography,
} from '@mui/material';
import { selectIsLoggedIn } from '../../common/auth/UserSlice';
import { useSelector } from 'react-redux';
import { LOGIN, SIGNUP, SUBSCRIPTION } from '../../routes/CONSTANTS';
import { useLocation, Link as RouterLink } from 'react-router-dom';

export default function PreviewMode() {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  let location = useLocation();
  return (
    <>
      <Card elevation={0} square sx={{ paddingTop: 2 }}>
        <CardContent>
          {isLoggedIn ? (
            <Typography textAlign={'left'}>
              You are currently viewing the LINKtivity Library in preview mode
              because your subscription is not currently active.{' '}
              <MaterialLink component={RouterLink} to={SUBSCRIPTION}>
                Click Here
              </MaterialLink>{' '}
              to manage your subscription.
            </Typography>
          ) : (
            <Typography textAlign={'left'}>
              You are currently viewing the LINKtivity Library in preview mode
              because you are not logged in.{' '}
              <MaterialLink component={RouterLink} to={SIGNUP}>
                Click Here
              </MaterialLink>{' '}
              to sign up for a free trial to get access, or{' '}
              <MaterialLink
                component={RouterLink}
                to={LOGIN}
                state={{ from: location }}
                replace
              >
                Login Here
              </MaterialLink>{' '}
              if you already have an account.
            </Typography>
          )}
        </CardContent>
      </Card>
    </>
  );
}
